module.exports = __webpack_public_path__ + "images/bailli-e25e1056cbd4e3075f29148847d7e389.jpg";